import { createFileRoute } from "@tanstack/react-router"
import { VerifiedPage } from "@/routes/verified"

export const Route = createFileRoute("/$lang/verified")({
  component: VerifiedPage,
})
